const container = document.querySelector('.scroll-spy');


/**
 * Returns true if the element's computed style is `position: sticky`.
 * @@param {!Element} el
 * @@return {boolean}
 */
function isSticky(el) {
    return getComputedStyle(el).position.match('sticky') !== null;
}

/**
 * Dispatches a `sticky-event` custom event on the element.
 * @@param {boolean} stuck
 * @@param {!Element} target Target element of event.
 */
function fire(stuck, target) {
    const evt = new CustomEvent('sticky-change', { detail: { stuck, target } });
    document.dispatchEvent(evt);
}

/**
 * @@param {!Element} container
 * @@param {string} className
 */
function addSentinels(container, className) {
    return Array.from(container.querySelectorAll('.anchor')).map(el => {
        const sentinel = document.createElement('div');
        sentinel.classList.add('sticky_sentinel', className);
        return el.parentElement.appendChild(sentinel);
    });
}

/**
 * Sets up an intersection observer to notify when elements with the class
 * `.sticky_sentinel--top` become visible/invisible at the top of the container.
 * @@param {!Element} container
 */
function observeHeaders(container) {
    const observer = new IntersectionObserver((records, observer) => {
        for (const record of records) {
            const targetInfo = record.boundingClientRect;
            const stickyTarget = record.target.parentElement.querySelector('.anchor');
            const rootBoundsInfo = record.rootBounds;

            if (targetInfo.bottom < rootBoundsInfo.top) {
                fire(true, stickyTarget);
            }

            if (targetInfo.bottom >= rootBoundsInfo.top &&
                targetInfo.bottom < rootBoundsInfo.bottom) {
                fire(false, stickyTarget);
            }
        }
    });

    // Add the bottom sentinels to each section and attach an observer.
    const sentinels = addSentinels(container, 'sticky_sentinel--top');
    sentinels.forEach(el => observer.observe(el));
}

/**
 * Sets up an intersection observer to notify when elements with the class
 * `.sticky_sentinel--bottom` become visible/invisible at the botton of the
 * container.
 * @@param {!Element} container
 */
function observeFooters(container) {
    const observer = new IntersectionObserver((records, observer) => {
        for (const record of records) {
            const targetInfo = record.boundingClientRect;
            const stickyTarget = record.target.parentElement.querySelector('.anchor');
            const rootBoundsInfo = record.rootBounds;
            const ratio = record.intersectionRatio;

            if (targetInfo.bottom > rootBoundsInfo.top && ratio === 1) {
                fire(true, stickyTarget);
            }

            if (targetInfo.top < rootBoundsInfo.top &&
                targetInfo.bottom < rootBoundsInfo.bottom) {
                fire(false, stickyTarget);
            }
        }
    });

    // Add the bottom sentinels to each section and attach an observer.
    const sentinels = addSentinels(container, 'sticky_sentinel--bottom');
    sentinels.forEach(el => observer.observe(el));
}

/**
 * Notifies when elements that have the class `sticky` begin to stick or not.
 * Note: these should be children of the `container` element.
 */
function notifyWhenStickyHeadersChange(container) {
    observeHeaders(container);
    observeFooters(container);
}

// function switchMobileView(isMobile) {
//     var width = $(window).width();
//     if (width <= 767) {
//         $('.faq-collapse').hide(50);
//     } else {
//         $('.faq-collapse').show(50);
//     }
// }

export function toogleCollapseMobileSection(id) {
    let v = document.getElementById("section-" + id + "-collapse");
    v.classList.toggle("show");
}

$(function() {

    // Feature detect warning after page content is generated.
    if (window.IntersectionObserver) {
        notifyWhenStickyHeadersChange(container);
    }

    const allTocsItems = Array.from(document.querySelectorAll('#scroll-spy-menu a'));

    document.addEventListener('sticky-change', function(e) {
        // Update sticking header title.
        const [header, stuck] = [e.detail.target, e.detail.stuck];
        header.classList.toggle('active-legal', stuck);

        // Update TOC selected item.
        allTocsItems.map(function(el) {
            const match = el.getAttribute('href').endsWith(header.id);
            el.classList.toggle('active-legal', match);
        });
    });

    $('[data-toggle="collapse"]').click(function() {
        var target = $(this).data('target');
        $(target).slideToggle();
    })

    $('.goto').on('click', function() { // Au clic sur un élément
        var page = $(this).is('a') ? $(this).attr('href') : $(this).data('target'); // Page cible
        var speed = 200; // Durée de l'animation (en ms)
        var offset = 180;
        $('html, body').animate({
            scrollTop: $(page).offset().top - offset
        }, speed); // Go
        return false;
    });
    // switchMobileView();
    // $(window).on('resize,orientationchange', switchMobileView)
})